<template>
    <div id="sidebar" 
            :class="{
                'large': isLarge(), 
                'small': isSmall()}">
        <BannerLite v-show="!isVisibleSideBar" />
        <!--
        <Banner v-show="isVisibleSideBar" />
        -->
        <SearchBar v-show="isVisibleSideBar" @onAutocompletePlaceChanged="onAutocompletePlaceChanged" />
        <FormFilter 
            v-if="sidebarMode == 'filters'"
            v-show="isVisibleSideBar"  />
        <PointList
            :points="currentPoints"
            v-if="sidebarMode == 'results'"
            v-show="isVisibleSideBar"
            @onSelectElementOfList="onSelectElementOfList"  />
            <br>
        <b-button 
            variant="info"
            size="sm"
            v-if="sidebarMode == 'results'"
            @click="backToFilterPanel">
            Volver al panel de filtros
        </b-button>
    </div>
</template>
<script>
    import { mapGetters, mapState, mapActions } from 'vuex';

    import Banner from "@/components/Banner.vue";
    import BannerLite from "@/components/BannerLite.vue";
    import FormFilter from "@/components/FormFilter.vue";
    import PointList from "@/components/PointList.vue";
    import SearchBar from "@/components/SearchBar";

    import consumer from "@/modules/consumer";

    const userMarkerIcon = require("@/assets/images/bluecircle.png");
    const puntoRedIcon = require("@/assets/images/punto_red_marker.png");
    const defaultImage = require("@/assets/images/default.gif");
    const placeImage = require("@/assets/images/icons8-marker-48.png");

    export default {
        name: "Sidebar",
        components : {
            Banner,
            BannerLite,
            FormFilter,
            PointList,
            SearchBar
        },
        computed: {
            ...mapState('points', {
                'currentPoints': "currentPoints"
            }),
            ...mapState('interface', {
                'sidebarMode': "sidebarMode",
            }),
            ...mapGetters('interface', {                
                'isVisibleSideBar': "isVisibleSideBar"
            })
        },
        methods:{
            isSmall(){
                return !this.isVisibleSideBar;
            },
            isLarge(){
                return this.isVisibleSideBar;
            },
            backToFilterPanel() {
                this.setSidebarModeFilters();
            },
            onSelectElementOfList(point) {
                this.$emit("onSelectElementOfList", point);
            },
            onAutocompletePlaceChanged(place, distance)  {
                var self = this;
                const { location } = place.geometry;
                consumer.getPointsAround(location.lng(), location.lat(), 200).then((response)=> {
                    var points = response.data.data;
                    self.paintPlaceAround(place, points.results, distance);
                });
            },
            paintPlaceAround(place, points, distance) {
                points = points.filter((p) => {return p.DISTANCIA <= distance;});
                if (!points || points.length == 0) {
                    alert("No se encontraron puntos cerca de esta ubicación.");
                    return;
                }
                const { location } = place.geometry;
                var self = this;
                self.setSidebarModeResults();
                this.setCurrentPoints(points);
                this.paintPoints(points);
                this.paintCircleAround(location, distance);
                /*** */
                window.mapInstance.addMarker("-1", location, {
                    icon: placeImage,
                    title: place.name
                });
                },
                paintCircleAround(center, population) {
                window.mapInstance.addCircle("CIRCLE_AROUND", center, population, {
                    strokeColor: '#343a40',
                    strokeOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: '#17a2b8',
                    fillOpacity: 0.2
                });
            }, 
            paintPoints(points) {
                window.mapInstance.cleanAllMarkers();
                window.mapInstance.cleanPolygons();
                var bounds = window.mapInstance.createBounds();
                var validPoints = false;
                for (var i in points) {
                    var point = points[i];
                    const {cx, cy} = point;
                    if(cx && cy){
                    var latLng = {
                        lat: parseFloat(point.cy),
                        lng: parseFloat(point.cx)
                    };
                    bounds.extend(latLng);
                    this.paintPoint(latLng, point);
                    validPoints = true;
                }        
            }
            if(validPoints)
                window.mapInstance.fitBounds(bounds);
            },
            paintPoint(latLng, point) {
                window.mapInstance.addMarker(point.puntored_id, latLng, {
                    icon: puntoRedIcon,
                    title: point.nombre_comercial,
                    infowin: this.infowinPoint(point),
                    markerOptions: {
                    zIndex: 100
                    }
                });
            },
            infowinPoint({
                direccion,
                imagen,
                nombre_ciudad,
                nombre_comercial,
                nombre_departamento,
                horario,
                cx,
                cy
                }) {
                if (!imagen) {
                    imagen = defaultImage;
                }
                if (!nombre_comercial) {
                    nombre_comercial = direccion;
                }
                return `
                    <div class="infowin_point">
                        <h1>${nombre_comercial}</h1>
                        <figure>
                            <img src="${imagen}" alt="Imagen del punto"/>
                        </figure>
                        <ul>
                            <li>
                            <strong>Dirección: </strong>
                            <span>${direccion}</span>
                            </li>
                            <li>
                            <strong>Horario: </strong>
                            <span>${horario}</span>
                            </li>
                            <li>
                            <strong>Ciudad: </strong>
                            <span>${nombre_ciudad}</span>
                            </li>
                            <li>
                            <strong>Departamento: </strong>
                            <span>${nombre_departamento}</span>
                            </li>
                            <li>
                            <button 
                                type="button" 
                                class="btn-gmaps btn btn-primary btn-sm"
                                onclick="OpenInGoogleMaps(${cy},${cx})"
                                >Ver en Google Maps</button>
                            </li>
                        </ul>
                    </div>
                `;
            },
            ...mapActions("points", {
                setCurrentPoints: "setCurrentPoints"
            }),
            ...mapActions("interface", {
                setSidebarModeFilters: "setSidebarModeFilters",
                setSidebarModeResults: "setSidebarModeResults",
                hideSidebar: "hideSidebar",
                showSidebar: "showSidebar"
            }),
        }
    }
</script>
<style lang="scss" >
    #sidebar {
        &.small{
            width: 44px;
            padding: 40px 7px;
        }
    }
</style>

